import React from 'react';
import { formatBackendEnumLabel, formatPlayerRoleLabel } from '../../../../helper/helper';
import { Images } from '../../../../utils/imageConstants';
import type { IJoinLeagueRequest } from '../types/request';

interface RequestCardProps {
  request: IJoinLeagueRequest;
  selected: boolean;
  onToggleSelect: () => void;
}

export const RequestCard: React.FC<RequestCardProps> = ({
  request,
  selected,
  onToggleSelect,
}) => {
  const req = request as IJoinLeagueRequest & {
    playerFirstName?: string;
    playerLastName?: string;
    playerRole?: string;
    battingStyle?: string;
    bowlingStyle?: string;
    imageUri?: string;
  };
  const name =
    [req.playerFirstName, req.playerLastName].filter(Boolean).join(' ') ||
    req.teamName ||
    req.teamSnapshotName ||
    '-';
  const teamId = req.teamCode ?? req.teamSnapshotId ?? req.teamId ?? '-';
  const role = formatPlayerRoleLabel(req.playerRole ?? req.role ?? req.teamRole ?? '-');
  const battingStyle = formatBackendEnumLabel(req.battingStyle ?? '-');
  const bowlingStyle = formatBackendEnumLabel(req.bowlingStyle ?? '-');

  const imageUrl = req.imageUri ?? req.imageUrl;
  const cdnBaseUrl = import.meta.env.VITE_IMAGE_CDN_BASE_URL;
  const avatarSrc =
    imageUrl && cdnBaseUrl
      ? `${cdnBaseUrl.replace(/\/$/, '')}/${String(imageUrl).replace(/^\//, '')}`
      : Images.team_member_placeholder;

  return (
    <div className={`request-card player-tab-card ${selected ? 'selected' : ''}`}>
      <div className="request-card-header">
        <div className="request-card-header-left">
          <div className="request-card-avatar">
            <img src={avatarSrc} alt="" />
          </div>
          <div className="request-card-info">
            <div className="request-card-name">{name}</div>
            <div className="request-card-team-id">
              <span className="request-card-team-id-label">Team ID :</span>{' '}
              <span className="request-card-team-id-value">{teamId}</span>
            </div>
          </div>
        </div>
        <div className="request-card-checkbox-wrap">
          <input
            type="checkbox"
            checked={selected}
            onChange={onToggleSelect}
            aria-label={`Select ${name}`}
          />
        </div>
      </div>
      <div className="request-card-details">
        <div className="request-card-col">
          <span className="request-card-label">Role:</span>
          <span className="request-card-value">{role}</span>
        </div>
        <div className="request-card-col request-card-col-sep">
          <span className="request-card-label">Batting Style:</span>
          <span className="request-card-value">{battingStyle}</span>
        </div>
        <div className="request-card-col request-card-col-sep">
          <span className="request-card-label">Bowling Style:</span>
          <span className="request-card-value">{bowlingStyle}</span>
        </div>
      </div>
    </div>
  );
};
